import { Skeleton } from '@/components/ui/skeleton';

/** Placeholder with the phone pre-join's exact layout, shown while the meeting loads. */
export function MobilePrejoinSkeleton() {
	return (
		<div className="fixed inset-0 flex flex-col bg-background">
			<div
				className="flex flex-1 flex-col overflow-hidden pt-[env(safe-area-inset-top)]"
				aria-busy="true"
				data-testid="mobile-prejoin-skeleton"
			>
				<div className="flex flex-none flex-col gap-2 px-4 pt-3 pb-4">
					<div className="flex h-10 items-center gap-3">
						<Skeleton className="size-10 rounded-full" />
						<Skeleton className="h-4 w-24 rounded-full" />
						<Skeleton className="ml-auto size-10 rounded-lg" />
						<Skeleton className="h-10 w-16 rounded-lg" />
					</div>
					<Skeleton className="h-5 w-56 rounded-full" />
				</div>
				<div className="px-4 pb-5">
					<Skeleton className="h-70 w-full rounded-2xl" />
				</div>
				<div className="flex flex-col gap-4 px-4">
					<div className="flex flex-col gap-2">
						<div className="flex items-center justify-between">
							<Skeleton className="h-3 w-12 rounded-full" />
							<Skeleton className="h-3 w-8 rounded-full" />
						</div>
						<Skeleton className="h-10 w-full rounded-lg" />
					</div>
					<div className="flex flex-col gap-2">
						<Skeleton className="h-3 w-10 rounded-full" />
						<Skeleton className="h-10 w-full rounded-lg" />
					</div>
					<Skeleton className="mt-1 h-12 w-full rounded-xl" />
					<Skeleton className="mx-auto h-3 w-3/5 rounded-full" />
					<Skeleton className="mx-auto h-3 w-2/5 rounded-full" />
				</div>
			</div>
		</div>
	);
}
